// extracted by mini-css-extract-plugin
export default {"badge":"NeutralBadge_badge__zveN+","amount":"NeutralBadge_amount__f+nTG"};